import script from "./LotGallery.vue?vue&type=script&setup=true&lang=ts"
export * from "./LotGallery.vue?vue&type=script&setup=true&lang=ts"

import "./LotGallery.vue?vue&type=style&index=0&id=7e876c95&lang=css"

const __exports__ = script;

export default __exports__